module.exports = __webpack_public_path__ + "static/media/paris.56960bd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paris.jpg
// module id = 967
// module chunks = 0